import React, { useEffect, useState } from 'react';
import { Link } from 'react-router';
import '../App.css';
import { useTranslation } from '../contexts/LanguageContext';
import { useGameStore } from '../store/gameStore';

export const GameLinkPage: React.FC = () => {
  const { generateBoard, gameId } = useGameStore();
  const { t } = useTranslation();
  const [isGenerating, setIsGenerating] = useState(false);

  useEffect(() => {
    // Generate a new board when the component mounts
    const generateNewGame = async () => {
      setIsGenerating(true);
      try {
        await generateBoard();
      } catch (error) {
        console.error('Failed to generate game:', error);
      } finally {
        setIsGenerating(false);
      }
    };

    generateNewGame();
  }, [generateBoard]);

  const copyToClipboard = async (url: string, label: string) => {
    const fullUrl = `${window.location.origin}${url}`;
    try {
      await navigator.clipboard.writeText(fullUrl);
      setCopiedUrl(url);
      setTimeout(() => setCopiedUrl(''), 2000); // Clear after 2 seconds
    } catch (err) {
      console.error('Failed to copy URL:', err);
    }
  };

  const [copiedUrl, setCopiedUrl] = useState<string>('');

  if (isGenerating || !gameId) {
    return (
      <div className="App">
        <div className="game-container">
          <h1 className="game-title">KODENAMES</h1>
          <p>{t.loading}</p>
        </div>
      </div>
    );
  }

  const playerGameUrl = `/board/${gameId}`;
  const spymasterGameUrl = `/board/${gameId}?spymaster=true`;

  return (
    <div className="App">
      <div className="game-container">
        <h1 className="game-title">KODENAMES</h1>
        
        <div className="game-link-container">
          <div className="game-link-row">
            <Link 
              to={playerGameUrl}
              className="player-view-button"
            >
              🕵️ {t.playGame}
            </Link>
            
            <button
              onClick={() => copyToClipboard(playerGameUrl, 'Player')}
              className={`share-button ${copiedUrl === playerGameUrl ? 'copied' : ''}`}
            >
              {copiedUrl === playerGameUrl ? `✓ ${t.linkCopied}` : `📋 ${t.copyLink}`}
            </button>
          </div>
          
          <div className="game-link-row">
            <Link 
              to={spymasterGameUrl}
              className="spymaster-view-button"
            >
              🎯 {t.spymasterView}
            </Link>
            
            <button
              onClick={() => copyToClipboard(spymasterGameUrl, 'Spymaster')}
              className={`share-button ${copiedUrl === spymasterGameUrl ? 'copied' : ''}`}
            >
              {copiedUrl === spymasterGameUrl ? `✓ ${t.linkCopied}` : `📋 ${t.copyLink}`}
            </button>
          </div>
        </div>

        <div className="back-home-container">
          <Link 
            to="/"
            className="back-home-button"
          >
            {t.backToMenu}
          </Link>
        </div>
      </div>
    </div>
  );
};
